import React from 'react';
import { defineMessages } from 'react-intl';

import { pickMaxInstallmentsOption, pickMaxInstallmentsOptionWithoutInterest } from '../modules/pickInstallments';
import { seller } from '../../mock';
import InstallmentsRenderer, { CSS_HANDLES } from '../ProductInstallmentsListItem/handles/InstallmentsRenderer';
import { useCssHandles } from '../../../utils/functions';

const messages = defineMessages({
	title: {
		id: 'admin/installments.title',
	},
	description: {
		id: 'admin/installments.description',
	},
	default: {
		id: 'store/installments.default',
	},
});

interface Props {
	message?: string;
	markers?: string[];
	installmentsCriteria?: 'max-quantity' | 'max-quantity-without-interest';
	installmentOptionsFilter?: {
		paymentSystemName?: string;
		installmentsQuantity?: number;
	};
	/** Used to override default CSS handles */
	blockClass?: string;
	componentId?: string;
}

function Installments({
	message = messages.default.id,
	markers = [],
	installmentsCriteria = 'max-quantity',
	installmentOptionsFilter,
	blockClass,
	componentId,
}: Props) {
	const { handles, withModifiers } = useCssHandles('vtex-product-price-1-x', CSS_HANDLES, blockClass);

	const commercialOffer = seller?.commertialOffer;

	if (!commercialOffer?.Installments || commercialOffer?.Installments?.length === 0) {
		return null;
	}

	let [installmentsOption] = commercialOffer.Installments;

	switch (installmentsCriteria) {
		case 'max-quantity-without-interest': {
			installmentsOption = pickMaxInstallmentsOptionWithoutInterest(
				commercialOffer.Installments,
				installmentOptionsFilter,
			);
			break;
		}

		default: {
			installmentsOption = pickMaxInstallmentsOption(commercialOffer.Installments, installmentOptionsFilter);
			break;
		}
	}

	return (
		<InstallmentsRenderer
			componentId={componentId}
			blockClass={blockClass}
			message={message}
			markers={markers}
			installment={installmentsOption}
			handles={handles}
			handlesModifierFunction={withModifiers}
		/>
	);
}

Installments.schema = {
	title: messages.title.id,
};

export default Installments;
